/* MCJ AUTH - mcj-auth.js | Manikchand Login & Signup logic */
(function(){
"use strict";
var MCJ = window.MCJ_AUTH = window.MCJ_AUTH || {};
var SEND_OTP_URL = "https://manikchand.app.n8n.cloud/webhook/mcj-send-otp";
var VERIFY_OTP_URL = "https://manikchand.app.n8n.cloud/webhook/mcj-verify-otp";
var SESSION_KEY = "mcj_user_session";
var RESEND_SECONDS = 65;
MCJ.countries = [
{f:"\uD83C\uDDEE\uD83C\uDDF3",n:"India",d:"+91"},
{f:"\uD83C\uDDFA\uD83C\uDDF8",n:"United States",d:"+1"},
{f:"\uD83C\uDDEC\uD83C\uDDE7",n:"United Kingdom",d:"+44"},
{f:"\uD83C\uDDE6\uD83C\uDDEA",n:"United Arab Emirates",d:"+971"},
{f:"\uD83C\uDDE6\uD83C\uDDFA",n:"Australia",d:"+61"},
{f:"\uD83C\uDDE8\uD83C\uDDE6",n:"Canada",d:"+1"},
{f:"\uD83C\uDDF8\uD83C\uDDEC",n:"Singapore",d:"+65"},
{f:"\uD83C\uDDF2\uD83C\uDDFE",n:"Malaysia",d:"+60"},
{f:"\uD83C\uDDF8\uD83C\uDDE6",n:"Saudi Arabia",d:"+966"},
{f:"\uD83C\uDDF3\uD83C\uDDF5",n:"Nepal",d:"+977"},
{f:"\uD83C\uDDF1\uD83C\uDDF0",n:"Sri Lanka",d:"+94"},
{f:"\uD83C\uDDE7\uD83C\uDDE9",n:"Bangladesh",d:"+880"}
];
MCJ.isDigit = function(c){ return c >= "0" && c <= "9"; };
MCJ.isPhone = function(v){ return /^[0-9]+$/.test(v.replace(/\s/g,"")); };
MCJ.isEmail = function(v){ return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v); };
MCJ.maskEmail = function(e){ if(!e||e.indexOf("@")<0) return e; var p=e.split("@"); var u=p[0]; var m=u.length<=3?u[0]+"***":u.slice(0,3)+"***"; return m+"@"+p[1]; };
MCJ.maskPhone = function(p){ if(!p) return ""; var s=(""+p).replace(/\D/g,""); return "*****"+s.slice(-5); };
MCJ.toast = function(msg, type, ms){
type = type || "info"; ms = ms || 3500;
var cont = document.querySelector(".mcj-toast-container");
if(!cont){ cont = document.createElement("div"); cont.className="mcj-toast-container"; document.body.appendChild(cont); }
var icon = type==="success" ? "\u2705" : type==="error" ? "\u2139\uFE0F" : "\u2139\uFE0F";
var t = document.createElement("div");
t.className = "mcj-toast " + type;
t.innerHTML = '<span class="mcj-toast-icon">'+icon+'</span><span>'+msg+'</span>';
cont.appendChild(t);
setTimeout(function(){ t.style.opacity="0"; t.style.transition="opacity .3s"; setTimeout(function(){ if(t.parentNode) t.parentNode.removeChild(t); }, 300); }, ms);
};
MCJ.getSession = function(){ try{ return JSON.parse(localStorage.getItem(SESSION_KEY)||"null"); }catch(e){ return null; } };
MCJ.setSession = function(obj){ try{ localStorage.setItem(SESSION_KEY, JSON.stringify(obj)); }catch(e){} };
MCJ.clearSession = function(){ try{ localStorage.removeItem(SESSION_KEY); }catch(e){} };
MCJ.logout = function(){ MCJ.clearSession(); window.location.href = "/account/logout"; };
MCJ.sendOtp = function(payload){
return fetch(SEND_OTP_URL, { method:"POST", headers:{"Content-Type":"application/json"}, body:JSON.stringify(payload) })
.then(function(r){ return r.json().catch(function(){ return {}; }); });
};
MCJ.verifyOtp = function(payload){
return fetch(VERIFY_OTP_URL, { method:"POST", headers:{"Content-Type":"application/json"}, body:JSON.stringify(payload) })
.then(function(r){ return r.json().catch(function(){ return {}; }); });
};
MCJ.openCountryPicker = function(onSelect){
var ov = document.createElement("div");
ov.className = "mcj-country-modal-overlay";
var html = '<div class="mcj-country-modal"><div class="mcj-country-modal-head">Search Country code</div>';
html += '<input class="mcj-country-search" type="text" placeholder="Type Country name or code"/>';
html += '<div class="mcj-country-list"></div></div>';
ov.innerHTML = html;
document.body.appendChild(ov);
var list = ov.querySelector(".mcj-country-list");
var search = ov.querySelector(".mcj-country-search");
function render(filter){
filter = (filter||"").toLowerCase();
var arr = MCJ.countries.slice().sort(function(a,b){ return a.n.localeCompare(b.n); });
list.innerHTML = "";
arr.forEach(function(c){
if(filter && c.n.toLowerCase().indexOf(filter)<0 && c.d.indexOf(filter)<0) return;
var item = document.createElement("div");
item.className = "mcj-country-item";
item.innerHTML = '<span class="mcj-country-flag">'+c.f+'</span><span class="mcj-country-name">'+c.n+'</span><span class="mcj-country-code">'+c.d+'</span>';
item.onclick = function(){ onSelect(c); close(); };
list.appendChild(item);
});
}
function close(){ if(ov.parentNode) ov.parentNode.removeChild(ov); }
search.oninput = function(){ render(search.value); };
ov.onclick = function(e){ if(e.target===ov) close(); };
render("");
search.focus();
};
MCJ.startResendTimer = function(timerEl, linkEl){
    var n = RESEND_SECONDS;
    if(linkEl) linkEl.classList.remove("show");
    if(timerEl) timerEl.parentNode.style.display = "";
    var iv = setInterval(function(){
    n--;
    if(timerEl) timerEl.textContent = n;
    if(n <= 0){
    clearInterval(iv);
    if(timerEl) timerEl.parentNode.style.display = "none";
    if(linkEl) linkEl.classList.add("show");
    }
    }, 1000);
    if(timerEl) timerEl.textContent = n;
    return iv;
    };
    MCJ.showStep = function(root, stepName){
    var steps = root.querySelectorAll(".mcj-step");
    for(var i=0;i<steps.length;i++){ steps[i].classList.remove("active"); }
    var target = root.querySelector('[data-step="'+stepName+'"]');
    if(target) target.classList.add("active");
    };
    /* Smart identifier input: toggles phone vs email mode */
    MCJ.initIdentifier = function(wrap){
    var textInput = wrap.querySelector(".mcj-id-text");
    var phoneWrap = wrap.querySelector(".mcj-phone-input-wrap");
    if(!textInput) return;
    function onInput(){
    var v = textInput.value;
    if(v.length>0 && MCJ.isDigit(v[0])){
    wrap.setAttribute("data-mode","phone");
    } else {
    wrap.setAttribute("data-mode","email");
    }
    }
    textInput.addEventListener("input", onInput);
    onInput();
    };
    /* ---- LOGIN PAGE CONTROLLER ---- */
    MCJ.initLogin = function(root){
    if(!root) return;
    var idWrap = root.querySelector(".mcj-identifier-wrap");
    var textInput = root.querySelector(".mcj-id-text");
    var phoneNum = root.querySelector(".mcj-phone-num-input");
    var countryBtn = root.querySelector(".mcj-country-btn");
    var tcCheck = root.querySelector(".mcj-tc-check");
    var continueBtn = root.querySelector(".mcj-continue-btn");
    var dialCode = "+91";
    MCJ.initIdentifier(idWrap);
    if(countryBtn){
    countryBtn.addEventListener("click", function(){
    MCJ.openCountryPicker(function(c){
    dialCode = c.d;
    countryBtn.querySelector(".mcj-cc-flag").textContent = c.f;
    countryBtn.querySelector(".mcj-cc-dial").textContent = c.d;
    });
    });
    }
    function syncBtn(){
    if(tcCheck && tcCheck.checked){ continueBtn.classList.remove("disabled"); continueBtn.disabled=false; }
    else { continueBtn.classList.add("disabled"); continueBtn.disabled=true; }
    }
    if(tcCheck){ tcCheck.addEventListener("change", syncBtn); syncBtn(); }
    function getIdentifier(){
    var mode = idWrap.getAttribute("data-mode");
    if(mode==="phone"){ return { type:"phone", value:(phoneNum.value||textInput.value).replace(/\D/g,""), dial:dialCode }; }
    return { type:"email", value:(textInput.value||"").trim() };
    }
    function fieldError(){
    var mode = idWrap.getAttribute("data-mode");
    if(mode==="phone"){ idWrap.querySelector(".mcj-phone-input-wrap").classList.add("mcj-error"); }
    else { textInput.classList.add("mcj-error"); }
    }
    function clearFieldError(){
    textInput.classList.remove("mcj-error");
    var pw = idWrap.querySelector(".mcj-phone-input-wrap");
    if(pw) pw.classList.remove("mcj-error");
    }
    continueBtn.addEventListener("click", function(){
    clearFieldError();
    var id = getIdentifier();
    if(id.type==="email"){
    if(!MCJ.isEmail(id.value)){ fieldError(); return; }
    MCJ.lookupCustomer(id).then(function(res){
    if(res.registered){ MCJ.gotoPasswordStep(root, id, res); }
    else { window.location.href = "/account/register?email="+encodeURIComponent(id.value); }
    });
    } else {
    if(id.value.length < 10){ fieldError(); return; }
    MCJ.gotoPhoneOtpStep(root, id);
    }
    });
    };
    /* Customer lookup - routes through n8n (which has Shopify access). */
    /* Expected response: { registered:bool, hasPhone:bool, phone:"", email:"", firstName:"" } */
    MCJ.lookupCustomer = function(id){
    var url = "https://manikchand.app.n8n.cloud/webhook/mcj-customer-lookup";
    return fetch(url, { method:"POST", headers:{"Content-Type":"application/json"}, body:JSON.stringify(id) })
    .then(function(r){ return r.json().catch(function(){ return {registered:false}; }); })
    .catch(function(){ return {registered:false}; });
    };
    /* STEP 2A - Password (registered email) */
    MCJ.gotoPasswordStep = function(root, id, info){
    info = info || {};
    MCJ.showStep(root, "password");
    var emailLbl = root.querySelector(".mcj-pw-email");
    if(emailLbl) emailLbl.textContent = id.value;
    var phoneLine = root.querySelector(".mcj-pw-phone-line");
    if(phoneLine){
    if(info.hasPhone && info.phone){ phoneLine.style.display=""; phoneLine.querySelector(".mcj-pw-phone-masked").textContent = "+91 "+MCJ.maskPhone(info.phone); }
    else { phoneLine.style.display="none"; }
    }
    var hidden = root.querySelector(".mcj-shopify-login-email");
    if(hidden) hidden.value = id.value;
    };
    /* STEP 2B - Phone OTP */
    MCJ.gotoPhoneOtpStep = function(root, id){
    MCJ.showStep(root, "phoneotp");
    var phoneLbl = root.querySelector(".mcj-otp-phone");
    if(phoneLbl) phoneLbl.textContent = id.dial+" "+id.value;
    root.setAttribute("data-otp-phone", id.value);
    root.setAttribute("data-otp-dial", id.dial);
    MCJ.sendOtp({ phone:id.dial.replace("+","")+id.value, source:"login" }).then(function(r){
    MCJ.toast("OTP sent successfully", "success");
    if(r && r.token) root.setAttribute("data-otp-token", r.token);
    var emailLine = root.querySelector(".mcj-otp-email-masked");
    if(emailLine && r && r.email){ emailLine.textContent = MCJ.maskEmail(r.email); }
    });
    var timer = root.querySelector('[data-step="phoneotp"] .mcj-resend-timer');
    var link = root.querySelector('[data-step="phoneotp"] .mcj-resend-link');
    MCJ.startResendTimer(timer, link);
    if(link){ link.onclick = function(){ MCJ.sendOtp({ phone:id.dial.replace("+","")+id.value, source:"login" }).then(function(r){ MCJ.toast("OTP sent successfully","success"); if(r&&r.token) root.setAttribute("data-otp-token",r.token); }); MCJ.startResendTimer(timer, link); }; }
    };
    /* STEP 2C - Email OTP */
    MCJ.gotoEmailOtpStep = function(root, email){
    MCJ.showStep(root, "emailotp");
    var emailLbl = root.querySelector(".mcj-eotp-email");
    if(emailLbl) emailLbl.textContent = email;
    root.setAttribute("data-otp-email", email);
    MCJ.sendOtp({ email:email, source:"login-email" }).then(function(r){ MCJ.toast("OTP sent successfully","success"); if(r&&r.token) root.setAttribute("data-otp-token",r.token); });
    var timer = root.querySelector('[data-step="emailotp"] .mcj-resend-timer');
    var link = root.querySelector('[data-step="emailotp"] .mcj-resend-link');
    MCJ.startResendTimer(timer, link);
    if(link){ link.onclick = function(){ MCJ.sendOtp({ email:email, source:"login-email" }).then(function(r){ MCJ.toast("OTP sent successfully","success"); }); MCJ.startResendTimer(timer, link); }; }
    };
    /* Wire up the in-card buttons for login steps */
    MCJ.wireLoginSteps = function(root){
    /* eye toggles */
    var eyes = root.querySelectorAll(".mcj-eye-toggle");
    for(var i=0;i<eyes.length;i++){
    (function(eye){
    eye.addEventListener("click", function(){
    var inp = eye.parentNode.querySelector("input");
    if(!inp) return;
    if(inp.type==="password"){ inp.type="text"; eye.setAttribute("data-open","1"); }
    else { inp.type="password"; eye.removeAttribute("data-open"); }
    });
    })(eyes[i]);
    }
    /* change links -> back to step 1 */
    var changeLinks = root.querySelectorAll(".mcj-change-to-step1");
    for(var j=0;j<changeLinks.length;j++){ changeLinks[j].addEventListener("click", function(){ MCJ.showStep(root, "identifier"); }); }
    /* password LOGIN button -> submit Shopify legacy login form */
    var pwBtn = root.querySelector(".mcj-pw-login-btn");
    if(pwBtn){
    pwBtn.addEventListener("click", function(){
    var pw = root.querySelector(".mcj-pw-input");
    var emailHidden = root.querySelector(".mcj-shopify-login-email");
    var pwHidden = root.querySelector(".mcj-shopify-login-pass");
    var form = root.querySelector(".mcj-shopify-login-form");
    if(pw && pwHidden && form){ pwHidden.value = pw.value; form.submit(); }
    });
    }
    /* GET OTP IN EMAIL -> step 2C */
    var getEmailOtp = root.querySelector(".mcj-get-email-otp");
    if(getEmailOtp){ getEmailOtp.addEventListener("click", function(){ var email = root.querySelector(".mcj-pw-email").textContent; MCJ.gotoEmailOtpStep(root, email); }); }
    /* LOGIN WITH PASSWORD (from email OTP) -> step 2A */
    var backToPw = root.querySelector(".mcj-back-to-password");
    if(backToPw){ backToPw.addEventListener("click", function(){ MCJ.showStep(root, "password"); }); }
    /* phone OTP LOGIN button */
    var phoneOtpBtn = root.querySelector(".mcj-phoneotp-login-btn");
    if(phoneOtpBtn){
    phoneOtpBtn.addEventListener("click", function(){
    var otpInput = root.querySelector('[data-step="phoneotp"] .mcj-otp-input');
    var errEl = root.querySelector('[data-step="phoneotp"] .mcj-error-text');
    var val = (otpInput.value||"").trim();
    otpInput.classList.remove("mcj-error"); if(errEl) errEl.classList.remove("show");
    if(!val){ otpInput.classList.add("mcj-error"); if(errEl) errEl.classList.add("show"); return; }
    var phone = root.getAttribute("data-otp-dial").replace("+","")+root.getAttribute("data-otp-phone");
    MCJ.verifyOtp({ phone:phone, otp:val, token:root.getAttribute("data-otp-token")||"", source:"login" }).then(function(r){
    if(r && r.valid){ MCJ.completeLogin(r); }
    else { otpInput.classList.add("mcj-error"); if(errEl){ errEl.textContent="Enter a valid OTP"; errEl.classList.add("show"); } }
    });
    });
    }
    /* email OTP LOGIN button */
    var emailOtpBtn = root.querySelector(".mcj-emailotp-login-btn");
    if(emailOtpBtn){
    emailOtpBtn.addEventListener("click", function(){
    var otpInput = root.querySelector('[data-step="emailotp"] .mcj-otp-input');
    var errEl = root.querySelector('[data-step="emailotp"] .mcj-error-text');
    var val = (otpInput.value||"").trim();
    otpInput.classList.remove("mcj-error"); if(errEl) errEl.classList.remove("show");
    if(!val){ otpInput.classList.add("mcj-error"); if(errEl) errEl.classList.add("show"); return; }
    MCJ.verifyOtp({ email:root.getAttribute("data-otp-email"), otp:val, token:root.getAttribute("data-otp-token")||"", source:"login-email" }).then(function(r){
    if(r && r.valid){ MCJ.completeLogin(r); }
    else { otpInput.classList.add("mcj-error"); if(errEl){ errEl.textContent="Enter a valid OTP"; errEl.classList.add("show"); } }
    });
    });
    }
    };
    MCJ.completeLogin = function(r){
    MCJ.setSession({ firstName:r.firstName||"", email:r.email||"", phone:r.phone||"", loggedIn:true, ts:Date.now() });
    if(r && r.multipass_url){ window.location.href = r.multipass_url; return; }
    window.location.href = "/";
    };
    /* ---- REGISTER PAGE CONTROLLER ---- */
    MCJ.initRegister = function(root){
    if(!root) return;
    var dialCode = "+91";
    var countryBtn = root.querySelector(".mcj-country-btn");
    var tcCheck = root.querySelector(".mcj-tc-check");
    var signupBtn = root.querySelector(".mcj-signup-btn");
    var f = {
    phone: root.querySelector(".mcj-reg-phone"),
    email: root.querySelector(".mcj-reg-email"),
    first: root.querySelector(".mcj-reg-first"),
    last: root.querySelector(".mcj-reg-last")
    };
    /* pre-fill email from query string */
    var qs = new URLSearchParams(window.location.search);
    if(qs.get("email") && f.email){ f.email.value = qs.get("email"); }
    if(countryBtn){
    countryBtn.addEventListener("click", function(){
    MCJ.openCountryPicker(function(c){ dialCode=c.d; countryBtn.querySelector(".mcj-cc-flag").textContent=c.f; countryBtn.querySelector(".mcj-cc-dial").textContent=c.d; });
    });
    }
    function syncBtn(){
    if(tcCheck && tcCheck.checked){ signupBtn.classList.remove("disabled"); signupBtn.disabled=false; }
    else { signupBtn.classList.add("disabled"); signupBtn.disabled=true; }
    }
    if(tcCheck){ tcCheck.addEventListener("change", syncBtn); syncBtn(); }
    function setErr(inp, msg){
    inp.classList.add("mcj-error");
    var e = inp.parentNode.querySelector(".mcj-error-text");
    if(e && msg){ e.textContent=msg; e.classList.add("show"); }
    }
    function clearErr(inp){
    inp.classList.remove("mcj-error");
    var e = inp.parentNode.querySelector(".mcj-error-text");
    if(e) e.classList.remove("show");
    }
    signupBtn.addEventListener("click", function(){
    [f.phone,f.email,f.first,f.last].forEach(clearErr);
    var ok = true;
    var phoneVal = (f.phone.value||"").replace(/\D/g,"");
    if(phoneVal.length<10){ setErr(f.phone,""); ok=false; }
    if(!MCJ.isEmail((f.email.value||"").trim())){ setErr(f.email,"Enter a valid Email ID"); ok=false; }
    if(!(f.first.value||"").trim()){ setErr(f.first,"Enter a valid First Name"); ok=false; }
    if(!(f.last.value||"").trim()){ setErr(f.last,"Enter a valid Last Name"); ok=false; }
    if(!ok) return;
    var email = (f.email.value||"").trim();
    MCJ.lookupCustomer({ type:"email", value:email }).then(function(res){
    if(res.registered){ MCJ.showRegisteredModal(email); }
    else { MCJ.doSignup(root, { phone:dialCode.replace("+","")+phoneVal, dial:dialCode, email:email, first:f.first.value.trim(), last:f.last.value.trim(), gender:(root.querySelector('input[name=mcj-gender]:checked')||{}).value||"", whatsapp:(root.querySelector(".mcj-wa-check")||{}).checked }); }
    });
    });
    };
    MCJ.doSignup = function(root, data){
    /* Send signup OTP for verification before creating account */
    MCJ.sendOtp({ email:data.email, source:"signup" }).then(function(r){
    MCJ.toast("OTP sent successfully","success");
    MCJ.showSignupOtpModal(data, r && r.token);
    });
    };
    /* Already-registered modal */
    MCJ.showRegisteredModal = function(email){
    var ov = document.createElement("div");
    ov.className = "mcj-modal-overlay";
    var h = '<div class="mcj-modal-box"><button class="mcj-modal-close">&times;</button>';
    h += '<div class="mcj-modal-lock">\uD83D\uDD12</div>';
    h += '<div class="mcj-modal-heading">'+email+' is already registered!</div>';
    h += '<div class="mcj-modal-sub">Enter OTP sent to this email to quickly Login</div>';
    h += '<input class="mcj-otp-input mcj-modal-otp" type="text" inputmode="numeric"/>';
    h += '<div class="mcj-error-text mcj-modal-otp-err">Enter a valid OTP</div>';
    h += '<div class="mcj-resend-wrap">RESEND IN <span class="mcj-resend-timer">65</span> SEC</div>';
    h += '<button class="mcj-resend-link">RESEND</button>';
    h += '<button class="mcj-btn-primary mcj-modal-verify">Verify &amp; Login</button>';
    h += '<div class="mcj-auth-footer"><a href="/account/login">Login with Password</a></div></div>';
    ov.innerHTML = h;
    document.body.appendChild(ov);
    var token = "";
    MCJ.sendOtp({ email:email, source:"already-registered" }).then(function(r){ if(r&&r.token) token=r.token; });
    var timer = ov.querySelector(".mcj-resend-timer");
    var link = ov.querySelector(".mcj-resend-link");
    MCJ.startResendTimer(timer, link);
    link.onclick = function(){ MCJ.sendOtp({ email:email, source:"already-registered" }).then(function(r){ if(r&&r.token) token=r.token; MCJ.toast("OTP sent successfully","success"); }); MCJ.startResendTimer(timer, link); };
    ov.querySelector(".mcj-modal-close").onclick = function(){ if(ov.parentNode) ov.parentNode.removeChild(ov); };
    ov.querySelector(".mcj-modal-verify").onclick = function(){
    var inp = ov.querySelector(".mcj-modal-otp");
    var err = ov.querySelector(".mcj-modal-otp-err");
    var val = (inp.value||"").trim();
    inp.classList.remove("mcj-error"); err.classList.remove("show");
    if(!val){ inp.classList.add("mcj-error"); err.classList.add("show"); return; }
    MCJ.verifyOtp({ email:email, otp:val, token:token, source:"already-registered" }).then(function(r){
    if(r&&r.valid){ MCJ.completeLogin(r); }
    else { inp.classList.add("mcj-error"); err.classList.add("show"); }
    });
    };
    };
    /* Signup OTP modal -> create account on success */
    MCJ.showSignupOtpModal = function(data, token){
    var ov = document.createElement("div");
    ov.className = "mcj-modal-overlay";
    var h = '<div class="mcj-modal-box"><button class="mcj-modal-close">&times;</button>';
    h += '<div class="mcj-modal-lock">\u2709\uFE0F</div>';
    h += '<div class="mcj-modal-heading">Verify your email</div>';
    h += '<div class="mcj-modal-sub">Enter the OTP sent to '+data.email+'</div>';
    h += '<input class="mcj-otp-input mcj-modal-otp" type="text" inputmode="numeric"/>';
    h += '<div class="mcj-error-text mcj-modal-otp-err">Enter a valid OTP</div>';
    h += '<div class="mcj-resend-wrap">RESEND IN <span class="mcj-resend-timer">65</span> SEC</div>';
    h += '<button class="mcj-resend-link">RESEND</button>';
    h += '<button class="mcj-btn-primary mcj-modal-verify">Verify &amp; Create Account</button></div>';
    ov.innerHTML = h;
    document.body.appendChild(ov);
    var tk = token||"";
    var timer = ov.querySelector(".mcj-resend-timer");
    var link = ov.querySelector(".mcj-resend-link");
    MCJ.startResendTimer(timer, link);
    link.onclick = function(){ MCJ.sendOtp({ email:data.email, source:"signup" }).then(function(r){ if(r&&r.token) tk=r.token; MCJ.toast("OTP sent successfully","success"); }); MCJ.startResendTimer(timer, link); };
    ov.querySelector(".mcj-modal-close").onclick = function(){ if(ov.parentNode) ov.parentNode.removeChild(ov); };
    ov.querySelector(".mcj-modal-verify").onclick = function(){
    var inp = ov.querySelector(".mcj-modal-otp");
    var err = ov.querySelector(".mcj-modal-otp-err");
    var val = (inp.value||"").trim();
    inp.classList.remove("mcj-error"); err.classList.remove("show");
    if(!val){ inp.classList.add("mcj-error"); err.classList.add("show"); return; }
    MCJ.verifyOtp({ email:data.email, otp:val, token:tk, source:"signup" }).then(function(r){
    if(r&&r.valid){ MCJ.createShopifyAccount(data, r); }
    else { inp.classList.add("mcj-error"); err.classList.add("show"); }
    });
    };
    };
    /* Create account: submit Shopify create_customer + log to Users sheet via n8n */
    MCJ.createShopifyAccount = function(data, otpRes){
    var saveUrl = "https://manikchand.app.n8n.cloud/webhook/mcj-user-save";
    fetch(saveUrl, { method:"POST", headers:{"Content-Type":"application/json"}, body:JSON.stringify({ phone:data.phone, email:data.email, firstName:data.first, lastName:data.last, gender:data.gender, whatsapp:data.whatsapp, source:"signup" }) }).catch(function(){});
    var form = document.querySelector(".mcj-shopify-register-form");
    if(form){
    form.querySelector("[name='customer[first_name]']").value = data.first;
    form.querySelector("[name='customer[last_name]']").value = data.last;
    form.querySelector("[name='customer[email]']").value = data.email;
    var pwField = form.querySelector("[name='customer[password]']");
    if(pwField) pwField.value = "MCJ-"+Math.random().toString(36).slice(2,10)+"!Aa1";
    MCJ.setSession({ firstName:data.first, email:data.email, phone:data.phone, loggedIn:true, ts:Date.now() });
    form.submit();
    } else {
    MCJ.setSession({ firstName:data.first, email:data.email, phone:data.phone, loggedIn:true, ts:Date.now() });
    window.location.href = "/";
    }
    };
    /* ---- RESET PASSWORD CONTROLLER ---- */
    MCJ.initReset = function(root){
    if(!root) return;
    var input = root.querySelector(".mcj-reset-input");
    var btn = root.querySelector(".mcj-reset-btn");
    if(!input || !btn) return;
    function sync(){ if((input.value||"").trim()){ btn.classList.remove("disabled"); btn.disabled=false; } else { btn.classList.add("disabled"); btn.disabled=true; } }
    input.addEventListener("input", sync); sync();
    btn.addEventListener("click", function(){
    var v = (input.value||"").trim();
    if(!v) return;
    if(MCJ.isPhone(v)){
    MCJ.sendOtp({ phone:v, source:"reset" }).then(function(r){ MCJ.toast("OTP sent successfully","success"); window.location.href = "/pages/reset-password-otp?phone="+encodeURIComponent(v); });
    } else {
    var rurl = "https://manikchand.app.n8n.cloud/webhook/mcj-reset-email";
    fetch(rurl, { method:"POST", headers:{"Content-Type":"application/json"}, body:JSON.stringify({ email:v }) }).catch(function(){});
    window.location.href = "/pages/reset-password-link-success?email="+encodeURIComponent(v);
    }
    });
    };
    /* Reset-link-success: re-trigger email */
    MCJ.initResetSuccess = function(root){
    if(!root) return;
    var qs = new URLSearchParams(window.location.search);
    var email = qs.get("email")||"";
    var emailEl = root.querySelector(".mcj-reset-success-email");
    if(emailEl) emailEl.textContent = email;
    var resend = root.querySelector(".mcj-reset-resend");
    if(resend){ resend.addEventListener("click", function(e){ e.preventDefault(); var rurl="https://manikchand.app.n8n.cloud/webhook/mcj-reset-email"; fetch(rurl,{method:"POST",headers:{"Content-Type":"application/json"},body:JSON.stringify({email:email})}).catch(function(){}); MCJ.toast("Email sent again","success"); }); }
    };
    /* Detect Shopify legacy login failure -> show wrong-password toast */
    MCJ.checkLoginError = function(){
    var qs = new URLSearchParams(window.location.search);
    if(qs.get("mcj_login_error")==="1"){ MCJ.toast("Invalid Email id or Password","info"); }
    };
    /* ---- BOOTSTRAP ---- */
    function init(){
    MCJ.checkLoginError();
    var loginRoot = document.querySelector(".mcj-login-root");
    if(loginRoot){ MCJ.initLogin(loginRoot); MCJ.wireLoginSteps(loginRoot); }
    var regRoot = document.querySelector(".mcj-register-root");
    if(regRoot){ MCJ.initRegister(regRoot); }
    var resetRoot = document.querySelector(".mcj-reset-root");
    if(resetRoot){ MCJ.initReset(resetRoot); }
    var resetSuccess = document.querySelector(".mcj-reset-success-root");
    if(resetSuccess){ MCJ.initResetSuccess(resetSuccess); }
    if(typeof MCJ.initHeader === "function"){ MCJ.initHeader(); }
    }
    if(document.readyState !== "loading"){ init(); }
    else { document.addEventListener("DOMContentLoaded", init); }
    })();
